const ProfitabilityChart = require('okCharts/ProfitabilityChart');

module.exports = ProfitabilityChart;
